import { mergeDeepRight } from 'ramda'

import { BillingValues } from '@ecm/data/Form'
import { validateZip } from '@ecm/ui/element/Form/Validation'

export type Billing = _Billing & {
  __Type: 'Billing'
}
export type _Billing = {
  billingAddress: string
  city: string
  company?: string
  countryCode: string
  firstName?: string
  lastName?: string
  phoneNumber: string
  stateCode: string
  uuid?: string
  remoteSubscriptionId?: string
  zipCode: string
}

const isValidBilling = (pBilling: Partial<Billing>) => {
  const isUsChosen = pBilling.countryCode === 'US'

  try {
    if (!pBilling.countryCode) {
      return false
    }

    if (isUsChosen) {
      if (!pBilling.billingAddress) {
        return false
      }
      if (!pBilling.city) {
        return false
      }
      if (!pBilling.stateCode) {
        return false
      }
      if (!pBilling.zipCode) {
        return false
      }
    }

    return true
  } catch {
    return false
  }
}

export const billing = (_b: _Billing): Billing => ({
  ..._b,
  __Type: 'Billing',
})

export const mapFormToBilling = (_b: BillingValues): Partial<Billing> => {
  return {
    billingAddress: _b.address || '',
    city: _b.city || '',
    company: _b.company || '',
    countryCode: _b.country || '',
    firstName: _b.fname || '',
    lastName: _b.lname || '',
    phoneNumber: _b.phone || '',
    stateCode: _b.state || '',
    zipCode: _b.zip || '',
  }
}

export const hasCompletedAddress = (billing: Billing): boolean => {
  const isUsChosen = billing.countryCode === 'US'

  if (billing.countryCode) {
    if (isUsChosen && validateZip(billing.zipCode)) {
      return false
    }
  } else {
    return false
  }

  if (isUsChosen) {
    if (!billing.stateCode) {
      return false
    }
    if (!billing.city) {
      return false
    }
    if (!billing.billingAddress) {
      return false
    }
  }

  return true
}

export const removeAddressIfNotComplete = (billing: Billing): Billing => {
  if (hasCompletedAddress(billing)) {
    return billing
  } else {
    return mergeDeepRight(billing, {
      billingAddress: '',
      city: '',
      countryCode: '',
      stateCode: '',
      zipCode: '',
    })
  }
}

export const hasAddressFieldsChanged = (oldBilling: Billing, newbililng: Partial<Billing>) => {
  const addressFieldsAreEqual =
    oldBilling.zipCode === newbililng.zipCode &&
    oldBilling.countryCode === newbililng.countryCode &&
    oldBilling.city === newbililng.city &&
    oldBilling.billingAddress === newbililng.billingAddress &&
    oldBilling.stateCode === newbililng.stateCode
  return !addressFieldsAreEqual
}

export const empty = (): Billing =>
  billing({
    billingAddress: '',
    city: '',
    company: '',
    countryCode: '',
    phoneNumber: '',
    stateCode: '',
    zipCode: '',
  })

export default {
  billing,
  empty,
  isValidBilling,
  mapFormToBilling,
}
